export interface TemplateDocument {
  id: string;
  name: string | null;
  projectId: string | null;
  documentType: TemplateType;
  s3Document: S3Document;
  templateVariable: TemplateVariable;
  sequence: number;
  createdAt: Date;
  updatedDate: Date | null;
  fileType: string;
}

export type TemplateDocumentUpdateDto = Pick<
  TemplateDocument,
  'id' | 'projectId' | 'sequence' | 'name' | 'documentType'
> & {
  templateVariableId: string;
  s3DocumentId: string;
};

export interface S3Document {
  id: string;
  s3Key: string;
  directUrl: string | null;
}

export interface TemplateVariable {
  id: string;
  name: string;
}

export interface TemplateDocumentSequenceDto {
  id: string;
  sequence: number;
}

export enum TemplateType {
  APS = 'APS',
  COOP = 'COOP',
  WELCOME_EMAIL = 'WELCOME_EMAIL'
  //OTHER = 'OTHER'
}

export const TEMPLATE_TYPE_LABELS: Record<TemplateType, string> = {
  [TemplateType.APS]: 'APS',
  [TemplateType.COOP]: 'COOP',

  [TemplateType.WELCOME_EMAIL]: 'Welcome Email'
  // [TemplateType.OTHER]: 'Other'
};
